// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import config from './config'
import store from '@/store'

import http from './api/http'
import router from './router'
import '@/assets/css/style.css'

import publicUi from "@/components/publicUi";
import Mixin from './mixins/page-mixer.js';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css' // 不要漏掉样式文件

// 全局注册
Vue.use(Viewer)



/* import echarts from 'echarts'

Vue.prototype.$echarts = echarts */

/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
//Vue.prototype.$api = api;//所有API集合


Vue.use(publicUi)
Vue.mixin(Mixin);
var vue=new Vue({
  el: '#app',
  router,
  store,
  components: { App},
  template: '<App/>'
})




Vue.prototype.http = http;
Vue.prototype.http.init(vue);
Vue.prototype.$EventBus=new Vue();//Vue.js事件总线,用于组件或页面间的通信
//Vue.prototype.http.init(vue);
// JWT 用户权限校验，判断 TOKEN 是否在 localStorage 当中
// router.beforeEach(({name}, from, next) => {
//   console.log("进入了路由")
//   // // 获取 JWT Token
//   // if (store.getters.getUserInfo()) {
//   //   // 如果用户在login页面
//   //   if (name === 'login') {
//   //     next('/');
//   //   } else {
//   //     next();
//   //   }
//   // } else {
//   //   if (name === 'login') {
//   //     next();
//   //   } else {
//   //     next({name: 'login'});
//   //   }
//   // }
// });


// WEBPACK FOOTER //
// ./src/main.js